import React from "react";
import { Col, Row, Tag, Flex } from "antd";
import dayjs from "dayjs";
import { formatIndianCurrency } from "../../../../../utills/helpers";

const Step2DetailsSection = ({ leadViewDetails, renderFileLinks }) => {
  const functionalDetail =
    leadViewDetails?.exchange_vehicle_functional_evaluation_detail;

  const formatValue = (value, type = "text") => {
    if (value === null || value === undefined || value === "") {
      return <p className="value">-</p>;
    }

    switch (type) {
      case "currency":
        return <p>{formatIndianCurrency(value)} </p>;
      case "date":
        return <p className="value">{dayjs(value).format("DD/MM/YYYY")}</p>;
      case "boolean":
        return (
          <Tag
            color={
              value === "Yes" ? "green" : value === "No" ? "red" : "default"
            }
            style={{ fontSize: "10px", margin: 0 }}
          >
            {value}
          </Tag>
        );
      default:
        return <p className="value">{value} </p>;
    }
  };

  const DetailItem = ({
    label,
    value,
    type = "text",
    cost = null,
    files = null,
  }) => (
    <Flex align="start" vertical>
      <Flex align="center" className="view-fields test1 w-100">
        <h6>{label}:</h6>
        {formatValue(value, type)}
      </Flex>
      {cost >= 0 && (
        <Flex className=" w-100">
          <Flex align="center" className="view-fields test2 w-100">
            <h6>Cost:</h6>
            <Flex align="center" gap={10} className="value">
              {formatValue(cost, "currency")}
              {files && renderFileLinks(files, false)}
            </Flex>
          </Flex>
        </Flex>
      )}
    </Flex>
  );

  return (
    <div style={{ padding: "16px 0" }}>
      <Row gutter={[24, 24]}>
        {/* Section 1 - First 10 fields */}
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Engine Oil Leakage"
            value={functionalDetail?.engine_oil_leakage}
            type="boolean"
            cost={
              functionalDetail?.engine_oil_leakage === "Yes"
                ? functionalDetail?.engine_oil_leakage_cost
                : null
            }
            files={
              functionalDetail?.engine_oil_leakage === "Yes"
                ? ["Engine Oil Leakage"]
                : null
            }
          />
          <DetailItem
            label="Coolant Leakage"
            value={functionalDetail?.coolant_leakage}
            type="boolean"
            cost={
              functionalDetail?.coolant_leakage === "Yes"
                ? functionalDetail?.coolant_leakage_cost
                : null
            }
            files={
              functionalDetail?.coolant_leakage === "Yes"
                ? ["Coolant Leakage"]
                : null
            }
          />
          <DetailItem
            label="Radiator Damage"
            value={functionalDetail?.radiator_damage}
            type="boolean"
            cost={
              functionalDetail?.radiator_damage === "Yes"
                ? functionalDetail?.radiator_damage_cost
                : null
            }
            files={
              functionalDetail?.radiator_damage === "Yes"
                ? ["Radiator Damage"]
                : null
            }
          />
          <DetailItem
            label="Starter Motor Defect"
            value={functionalDetail?.starter_motor_defect}
            type="boolean"
            cost={
              functionalDetail?.starter_motor_defect === "Yes"
                ? functionalDetail?.starter_motor_defect_cost
                : null
            }
            files={
              functionalDetail?.starter_motor_defect === "Yes"
                ? ["Starter Motor Defect"]
                : null
            }
          />
          <DetailItem
            label="Engine Noise"
            value={functionalDetail?.engine_noise}
            type="boolean"
            cost={
              functionalDetail?.engine_noise === "Yes"
                ? functionalDetail?.engine_noise_cost
                : null
            }
            files={
              functionalDetail?.engine_noise === "Yes" ? ["Engine Noise"] : null
            }
          />
          <DetailItem
            label="Low Pickup"
            value={functionalDetail?.low_pickup}
            type="boolean"
            cost={
              functionalDetail?.low_pickup === "Yes"
                ? functionalDetail?.low_pickup_cost
                : null
            }
            files={
              functionalDetail?.low_pickup === "Yes" ? ["Low Pickup"] : null
            }
          />
          <DetailItem
            label="Engine Smoke"
            value={functionalDetail?.engine_smoke}
            cost={
              functionalDetail?.engine_smoke &&
              functionalDetail?.engine_smoke !== "None"
                ? functionalDetail?.engine_smoke_cost
                : null
            }
            files={
              functionalDetail?.engine_smoke &&
              functionalDetail?.engine_smoke !== "None"
                ? ["Engine Smoke"]
                : null
            }
          />
          <DetailItem
            label="Defective Belts"
            value={functionalDetail?.defective_belts}
            type="boolean"
            cost={
              functionalDetail?.defective_belts === "Yes"
                ? functionalDetail?.defective_belts_cost
                : null
            }
            files={
              functionalDetail?.defective_belts === "Yes"
                ? ["Defective Belts"]
                : null
            }
          />
          <DetailItem
            label="Engine Replaced Endorsed"
            value={functionalDetail?.engine_replaced_endorsed}
            type="boolean"
            cost={
              functionalDetail?.engine_replaced_endorsed === "Yes"
                ? functionalDetail?.engine_replaced_endorsed_cost
                : null
            }
            files={
              functionalDetail?.engine_replaced_endorsed === "Yes"
                ? ["Engine Replaced Endorsed"]
                : null
            }
          />
          <DetailItem
            label="Rough Engine"
            value={functionalDetail?.rough_engine}
            type="boolean"
            cost={
              functionalDetail?.rough_engine === "Yes"
                ? functionalDetail?.rough_engine_cost
                : null
            }
            files={
              functionalDetail?.rough_engine === "Yes" ? ["Rough Engine"] : null
            }
          />
          <DetailItem
            label="Engine RPM Defect"
            value={functionalDetail?.engine_rpm_defect}
            type="boolean"
            cost={
              functionalDetail?.engine_rpm_defect === "Yes"
                ? functionalDetail?.engine_rpm_defect_cost
                : null
            }
            files={
              functionalDetail?.engine_rpm_defect === "Yes"
                ? ["Engine RPM Defect"]
                : null
            }
          />
          <DetailItem
            label="Brake Disk Damage"
            value={functionalDetail?.brake_disk_damage}
            type="boolean"
            cost={
              functionalDetail?.brake_disk_damage === "Yes"
                ? functionalDetail?.brake_disk_damage_cost
                : null
            }
            files={
              functionalDetail?.brake_disk_damage === "Yes"
                ? ["Brake Disk Damage"]
                : null
            }
          />
        </Col>

        {/* Section 2 - Next 10 fields */}
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Brake Defect"
            value={functionalDetail?.brake_defect}
            type="boolean"
            cost={
              functionalDetail?.brake_defect === "Yes"
                ? functionalDetail?.brake_defect_cost
                : null
            }
            files={
              functionalDetail?.brake_defect === "Yes" ? ["Brake Defect"] : null
            }
          />
          <DetailItem
            label="ABS/EBD Defect"
            value={functionalDetail?.abs_ebd_defect}
            type="boolean"
            cost={
              functionalDetail?.abs_ebd_defect === "Yes"
                ? functionalDetail?.abs_ebd_defect_cost
                : null
            }
            files={
              functionalDetail?.abs_ebd_defect === "Yes"
                ? ["ABS EBD Defect"]
                : null
            }
          />
          <DetailItem
            label="Keyless Cylinder Defect"
            value={functionalDetail?.keyless_cylinder_defect}
            type="boolean"
            cost={
              functionalDetail?.keyless_cylinder_defect === "Yes"
                ? functionalDetail?.keyless_cylinder_defect_cost
                : null
            }
            files={
              functionalDetail?.keyless_cylinder_defect === "Yes"
                ? ["Keyless Cylinder Defect"]
                : null
            }
          />
          <DetailItem
            label="Warning Lamp Defect"
            value={functionalDetail?.warning_lamp_defect}
            type="boolean"
            cost={
              functionalDetail?.warning_lamp_defect === "Yes"
                ? functionalDetail?.warning_lamp_defect_cost
                : null
            }
            files={
              functionalDetail?.warning_lamp_defect === "Yes"
                ? ["Warning Lamp Defect"]
                : null
            }
          />
          <DetailItem
            label="Infotainment System Defect"
            value={functionalDetail?.infotainment_system_defect}
            cost={
              functionalDetail?.infotainment_system_defect &&
              functionalDetail?.infotainment_system_defect !== "Ok"
                ? functionalDetail?.infotainment_system_defect_cost
                : null
            }
            files={
              functionalDetail?.infotainment_system_defect &&
              functionalDetail?.infotainment_system_defect !== "Ok"
                ? ["Infotainment System Defect"]
                : null
            }
          />
          <DetailItem
            label="Head Lamp Defect"
            value={functionalDetail?.head_lamp_defect}
            type="boolean"
            cost={
              functionalDetail?.head_lamp_defect === "Yes"
                ? functionalDetail?.head_lamp_defect_cost
                : null
            }
            files={
              functionalDetail?.head_lamp_defect === "Yes"
                ? ["Head Lamp Defect"]
                : null
            }
          />
          <DetailItem
            label="Fog Lamp Defect"
            value={functionalDetail?.fog_lamp_defect}
            type="boolean"
            cost={
              functionalDetail?.fog_lamp_defect === "Yes"
                ? functionalDetail?.fog_lamp_defect_cost
                : null
            }
            files={
              functionalDetail?.fog_lamp_defect === "Yes"
                ? ["Fog Lamp Defect"]
                : null
            }
          />
          <DetailItem
            label="Horn Defect"
            value={functionalDetail?.horn_defect}
            type="boolean"
            cost={
              functionalDetail?.horn_defect === "Yes"
                ? functionalDetail?.horn_defect_cost
                : null
            }
            files={
              functionalDetail?.horn_defect === "Yes" ? ["Horn Defect"] : null
            }
          />
          <DetailItem
            label="Wiper Operation Defect"
            value={functionalDetail?.wiper_defect}
            cost={
              functionalDetail?.wiper_defect &&
              functionalDetail?.wiper_defect !== "None"
                ? functionalDetail?.wiper_defect_cost
                : null
            }
            files={
              functionalDetail?.wiper_defect &&
              functionalDetail?.wiper_defect !== "None"
                ? ["Wiper Defect"]
                : null
            }
          />
          <DetailItem
            label="Navigation System Defect"
            value={functionalDetail?.navigation_system_defect}
            type="boolean"
            cost={
              functionalDetail?.navigation_system_defect === "Yes"
                ? functionalDetail?.navigation_system_defect_cost
                : null
            }
            files={
              functionalDetail?.navigation_system_defect === "Yes"
                ? ["Navigation System Defect"]
                : null
            }
          />
          <DetailItem
            label="Analog Music System Defect"
            value={functionalDetail?.analog_music_system_defect}
            type="boolean"
            cost={
              functionalDetail?.analog_music_system_defect === "Yes"
                ? functionalDetail?.analog_music_system_defect_cost
                : null
            }
            files={
              functionalDetail?.analog_music_system_defect === "Yes"
                ? ["Analog Music System Defect"]
                : null
            }
          />
          <DetailItem
            label="Cruise Control Defect"
            value={functionalDetail?.cruise_control_defect}
            type="boolean"
            cost={
              functionalDetail?.cruise_control_defect === "Yes"
                ? functionalDetail?.cruise_control_defect_cost
                : null
            }
            files={
              functionalDetail?.cruise_control_defect === "Yes"
                ? ["Cruise Control Defect"]
                : null
            }
          />
        </Col>

        {/* Section 3 - Next 10 fields */}
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Steering Wheel Control Defect"
            value={functionalDetail?.steering_wheel_control_defect}
            type="boolean"
            cost={
              functionalDetail?.steering_wheel_control_defect === "Yes"
                ? functionalDetail?.steering_wheel_control_defect_cost
                : null
            }
            files={
              functionalDetail?.steering_wheel_control_defect === "Yes"
                ? ["Steering Wheel Control Defect"]
                : null
            }
          />
          <DetailItem
            label="Electronic Mirror Defect"
            value={functionalDetail?.electronic_mirror_defect}
            type="boolean"
            cost={
              functionalDetail?.electronic_mirror_defect === "Yes"
                ? functionalDetail?.electronic_mirror_defect_cost
                : null
            }
            files={
              functionalDetail?.electronic_mirror_defect === "Yes"
                ? ["Electronic Mirror Defect"]
                : null
            }
          />
          <DetailItem
            label="Battery Defect"
            value={functionalDetail?.battery_defect}
            type="boolean"
            cost={
              functionalDetail?.battery_defect === "Yes"
                ? functionalDetail?.battery_defect_cost
                : null
            }
            files={
              functionalDetail?.battery_defect === "Yes"
                ? ["Battery Defect"]
                : null
            }
          />
          <DetailItem
            label="Music System Defect"
            value={functionalDetail?.music_system_defect}
            type="boolean"
            cost={
              functionalDetail?.music_system_defect === "Yes"
                ? functionalDetail?.music_system_defect_cost
                : null
            }
            files={
              functionalDetail?.music_system_defect === "Yes"
                ? ["Music System Defect"]
                : null
            }
          />
          <DetailItem
            label="Power Window Defect"
            value={functionalDetail?.power_window_defect}
            type="boolean"
            cost={
              functionalDetail?.power_window_defect === "Yes"
                ? functionalDetail?.power_window_defect_cost
                : null
            }
            files={
              functionalDetail?.power_window_defect === "Yes"
                ? ["Power Window Defect"]
                : null
            }
          />
          <DetailItem
            label="Auto Headlight Wiper Defect"
            value={functionalDetail?.auto_headlight_wiper_defect}
            type="boolean"
            cost={
              functionalDetail?.auto_headlight_wiper_defect === "Yes"
                ? functionalDetail?.auto_headlight_wiper_defect_cost
                : null
            }
            files={
              functionalDetail?.auto_headlight_wiper_defect === "Yes"
                ? ["Auto Headlight Wiper Defect"]
                : null
            }
          />
          <DetailItem
            label="Electronic TailGate Defect"
            value={functionalDetail?.electronic_tailgate_defect}
            type="boolean"
            cost={
              functionalDetail?.electronic_tailgate_defect === "Yes"
                ? functionalDetail?.electronic_tailgate_defect_cost
                : null
            }
            files={
              functionalDetail?.electronic_tailgate_defect === "Yes"
                ? ["Electronic Tailgate Defect"]
                : null
            }
          />
          <DetailItem
            label="Parking Sensor Defect"
            value={functionalDetail?.parking_sensor_defect}
            type="boolean"
            cost={
              functionalDetail?.parking_sensor_defect === "Yes"
                ? functionalDetail?.parking_sensor_defect_cost
                : null
            }
            files={
              functionalDetail?.parking_sensor_defect === "Yes"
                ? ["Parking Sensor Defect"]
                : null
            }
          />
          <DetailItem
            label="AC Defective"
            value={functionalDetail?.ac_defective}
            type="boolean"
            cost={
              functionalDetail?.ac_defective === "Yes"
                ? functionalDetail?.ac_defective_cost
                : null
            }
            files={
              functionalDetail?.ac_defective === "Yes" ? ["AC Defective"] : null
            }
          />
          <DetailItem
            label="Roof AC"
            value={functionalDetail?.roof_ac}
            type="boolean"
            cost={
              functionalDetail?.roof_ac === "Yes"
                ? functionalDetail?.roof_ac_cost
                : null
            }
            files={functionalDetail?.roof_ac === "Yes" ? ["Roof AC"] : null}
          />
          <DetailItem
            label="Ventilated Seat Defect"
            value={functionalDetail?.ventilated_seat_defect}
            type="boolean"
            cost={
              functionalDetail?.ventilated_seat_defect === "Yes"
                ? functionalDetail?.ventilated_seat_defect_cost
                : null
            }
            files={
              functionalDetail?.ventilated_seat_defect === "Yes"
                ? ["Ventilated Seat Defect"]
                : null
            }
          />
          <DetailItem
            label="Electronic Seat Defect"
            value={functionalDetail?.electronic_seat_defect}
            type="boolean"
            cost={
              functionalDetail?.electronic_seat_defect === "Yes"
                ? functionalDetail?.electronic_seat_defect_cost
                : null
            }
            files={
              functionalDetail?.electronic_seat_defect === "Yes"
                ? ["Electronic Seat Defect"]
                : null
            }
          />
        </Col>

        {/* Section 4 - Last 11 fields */}
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Paddle Shift Defect"
            value={functionalDetail?.paddle_shift_defect}
            type="boolean"
            cost={
              functionalDetail?.paddle_shift_defect === "Yes"
                ? functionalDetail?.paddle_shift_defect_cost
                : null
            }
            files={
              functionalDetail?.paddle_shift_defect === "Yes"
                ? ["Paddle Shift Defect"]
                : null
            }
          />
          <DetailItem
            label="Tyre Pressuring Monitoring System Defect"
            value={functionalDetail?.tyre_pressuring_monitoring_system_defect}
            type="boolean"
            cost={
              functionalDetail?.tyre_pressuring_monitoring_system_defect ===
              "Yes"
                ? functionalDetail?.tyre_pressuring_monitoring_system_defect_cost
                : null
            }
            files={
              functionalDetail?.tyre_pressuring_monitoring_system_defect ===
              "Yes"
                ? ["Tyre Pressuring Monitoring System Defect"]
                : null
            }
          />
          <DetailItem
            label="Sun Roof Defect"
            value={functionalDetail?.sun_roof_defect}
            type="boolean"
            cost={
              functionalDetail?.sun_roof_defect === "Yes"
                ? functionalDetail?.sun_roof_defect_cost
                : null
            }
            files={
              functionalDetail?.sun_roof_defect === "Yes"
                ? ["Sun Roof Defect"]
                : null
            }
          />
          <DetailItem
            label="Rear View Mirror IRVM"
            value={functionalDetail?.rear_view_mirror_irvm}
            type="boolean"
            cost={
              functionalDetail?.rear_view_mirror_irvm === "Yes"
                ? functionalDetail?.rear_view_mirror_irvm_cost
                : null
            }
            files={
              functionalDetail?.rear_view_mirror_irvm === "Yes"
                ? ["Rear View Mirror IRVM"]
                : null
            }
          />
          <DetailItem
            label="Rear View Mirror ORVM"
            value={functionalDetail?.rear_view_mirror_orvm}
            type="boolean"
            cost={
              functionalDetail?.rear_view_mirror_orvm === "Yes"
                ? functionalDetail?.rear_view_mirror_orvm_cost
                : null
            }
            files={
              functionalDetail?.rear_view_mirror_orvm === "Yes"
                ? ["Rear View Mirror ORVM"]
                : null
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default Step2DetailsSection;
